/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1544__part-2
 */

"use strict"

import * as /* [auto-meaningful-name] */Classnames from /* 8 */"classnames"
import /* [auto-meaningful-name] */Classnames1 from /* 8 */"classnames"
function x(e, t, n) {
  return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1]
}
export { x }
